import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import * as serviceWorker from './serviceWorker.js'
createRoot(document.getElementById('root')).render(
  
  <App />

)

serviceWorker.unregister();